import getWithFallback from "./ajax";

export default (function () {
    return {
        sliderArticles: {
            'carousel_slider_top': {'news': [], 'categories': [], 'sources': [], 'menu_type': ''},
            'carousel_slider_bottom': {'news': [], 'categories': [], 'sources': [], 'menu_type': ''}
        },

        categoryTop: 21,
        categoryAll: 0,

        // Add newsHash to news item links so it later could be used in modal window to get full news data
        addDataToNewsLink: function ($div, currNews) {
            var obj = $div.is('a') ? $div : $div.find('a').first();

            obj.attr('data-news_item_hash', currNews.newsHash);

            return $div;
        },
        getTopProvider: function () {
            return 0;
        },
        getFeedData: function (url, fallbackUrl, categoryType, sourceId, categoryId, getFeedDataCallback) {
            var feedUrl = this.getFeedLink(url, categoryType, sourceId, categoryId);
            var feedFallbackUrl = this.getFeedLink(fallbackUrl, categoryType, sourceId, categoryId);

            getWithFallback(feedUrl, feedFallbackUrl, function(data) {
                getFeedDataCallback(data);
            });
        },
        getFeedLink: function (url, categoryType, sourceId, categoryId) {

            return url.replace('#SOURCE_ID#', sourceId).replace('#CATEGORY_ID#', categoryId);
        },
        getNewsItemData: function (obj) {
            var sliderId = obj.closest('.carousel_outer_wrap').attr('id');

            var newsHash = obj.data('news_item_hash');
            var len = this.sliderArticles[sliderId].news.length;
            for (var i = 0; i < len; i++) {
                if (this.sliderArticles[sliderId].news[i].newsHash === newsHash) {
                    return this.sliderArticles[sliderId].news[i];
                }
            }
            //should not happen but if happens jo js error occur
            return {'newsSource': {}};
        },
        // Set items in item cache so alter this data can be used to open modal window
        setFilteredSliderData: function (carouselOuterWrapperID, filteredNewsItems, categories, sources) {
            var newsItems = filteredNewsItems.slice(0); //clone array

            this.sliderArticles[carouselOuterWrapperID] = {
                'news': newsItems,
                'categories': categories,
                'sources': sources
            };
        }
    };
}());
